import { makeStyles } from 'tss-react/mui';

export const useH1TagStyles = makeStyles()(() => ({
  title: {
    position: 'absolute',
    overflow: 'hidden',

    width: 1,
    height: 1,
    margin: -1,
    padding: 0,

    border: 0,

    clip: 'rect(0, 0, 0, 0)',

    whiteSpace: 'nowrap',
  },
}));
